import {Box, IconButton, Skeleton, Switch, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { DataGrid,  } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import { PermissionGuard } from '../../../../components/PermissionGuard';
import { useNavigate } from 'react-router-dom';
import { Edit } from '@mui/icons-material';
import { BannerServices } from '../BannerServices';
import { useForm } from 'react-hook-form';
import Loading from '../../../../components/Loader/Loading';
import { formatDateTime } from '../../../../utils/dateUtils';
import MultiColumnFilter from '../../../../components/Filter/MultiColumnFilter';
import QuickSearchTool from '../../../../components/QuickSearch/QuickSearchTool';
import NoRowsLayout from '../../../../components/Layout/NoRowsLayout';
import useResponsive from '../../../../hooks/useResponsive';
import { CustomerBannerContext } from './CustomerBanners';

const SliderList = () => {
  const {isSm} = useResponsive();
  const {list,setList,loading,fetchBannerList,allRowCount,paginationModel,handlePaginationChange,handleSortingChange,sortModel,handleStatusChange} = useContext(CustomerBannerContext);
  /************************  Table Column Manage **************************** */
  const columns = [
    { 
      field: 'imageUrl', 
      headerName: 'Banner', 
      headerAlign:'center',
      flex: 2,
      // filterable: false,
      sortable: false,
      // valueGetter: (params) => {
      //   // Join all subcategory titles into a single searchable string
      //   const title = params.row.title;
      //   const referenceType = params.row.referenceType;
      //   const issueDate = formatDateTime(params.row.issueDate,'date');
      //   const rewardValue = params.row.rewardValue;
      //   const walletType = params.row.walletType;
      //   const expireDate = formatDateTime(params.row.expireDate,'date');
      //   const maxRewardValue = params.row.maxRewardValue;
      //   return `${title} ${referenceType} ${issueDate} ${rewardValue} ${walletType} ${expireDate} ${maxRewardValue}`.toLowerCase();
      // },
      renderCell: (params) => (
        <Box sx={{ display: 'flex',alignItems:'center' ,width:'100%',p:1}}>
          <Box sx={{ width:'100%'}}>
            {params.row.imageUrl ? (
              <img 
              //   src={params.row.images} 
                src={`${process.env.REACT_APP_IMAGE_STORE_PATH}/${params.row?.imageUrl}`}
                alt={params.row.title}
                style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
              />
            ) : (
              <Skeleton variant="rectangular" width={35} height={35} animation={false} />
            )}
          </Box>
        
        </Box>
      ),
    },
    { 
      field: 'details', 
      headerName: 'Details', 
      headerAlign: 'center',sortable:false,
      filterable: false,
      flex:2,
      sortable: false,
      renderCell: (params) => {   
        return (
          <Box sx={{width:'100%'}}>
            <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
              <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Title</Typography>
              <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
              <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row.title || 'N/A'}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
              <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Display On</Typography>
              <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
              <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row.platformName || 'N/A'}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
              <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Category</Typography>
              <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
              <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row.bannerCategory || 'N/A'}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
              <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Position</Typography>
              <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
              <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row.bannerPosition || 'N/A'}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
              <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Type</Typography>
              <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
              <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row.bannerType || 'N/A'}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
              <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Is Slider</Typography>
              <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
              <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row?.isSlider ? 'Yes' : 'No' || 'N/A'}</Typography>
            </Box>
            { params.row.bannerType == 'interactive' &&
              <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
                <Typography sx={{width:'25%',fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>Link</Typography>
                <Typography sx={{fontWeight:500,color:'#3e3e3e',fontSize:'0.65rem'}}>:</Typography>
                <Typography sx={{fontWeight:400,color:'#3e3e3e',fontSize:'0.65rem'}}>{params.row.appUrl || params.row.linkUrl || 'N/A'}</Typography>
              </Box>
            }
          </Box>
        );
      },
    },
    {
      field: 'displayPeriod',
      headerName: 'Display Period',
      headerAlign:'center',
      flex: 1.5,
      filterable: false,
      sortable:false,
      valueGetter: (params) => {
        const startDate = params.row.issueDate ? formatDateTime(params.row.issueDate,'date'):'N/A';
        const endDate = params.row.expireDate ? formatDateTime(params.row.expireDate,'date'):'N/A';
        return `${startDate} to ${endDate}`;
      },
      renderCell:(params)=>{
        return (
          <Box sx={{display:'flex',flexDirection:'column',gap:1}}>
            <Typography sx={{fontSize:'0.5rem'}}> <Box component={'span'} sx={{fontWeight:600}}>Start Date: </Box>{params.row.startDate ? formatDateTime(params.row.startDate):'N/A'}</Typography>            
            <Typography sx={{fontSize:'0.5rem'}}> <Box component={'span'} sx={{fontWeight:600}}>Expiry Date: </Box>{params.row.expireDate ? formatDateTime(params.row.expireDate):'N/A'}</Typography>
          </Box>
        )
      }
    },
    { 
      field: 'status', 
      headerName: 'Status', 
      headerAlign:'center',
      flex: .5,
      sortable: false,
      valueGetter: (params) => {
        return params.row.status == 'active' ? 'Active' : 'Inactive';
      } ,
      renderCell: (params) => {
        return(       
        <PermissionGuard feature='banner' permission='canEdit'>
          <Box sx={{display:'flex',flexDirection:'column',gap:1,alignItems:'center',width:'100%'}}>
              <Switch
                size='small'
                checked={params.row.status == 'active'}
                onChange={()=>handleStatusChange({status: params.row.status == 'active' ? 'inactive':'active'},params.row.id)}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': {
                      color: 'success.main',
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: 'success.main'
                  },
                  '& .MuiSwitch-switchBase': {
                      color: 'error.main',
                  },
                  '& .MuiSwitch-track': {
                      backgroundColor: 'error.main'
                  }
                }}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              <Typography
                variant="body2"
                size="small"
                sx={{
                  color: params.row?.status=='active' ? 'success.main' : 'error.main',
                  fontWeight: '600',
                  fontSize:'.65rem'
                }}
              >
                {params.row?.status == 'active' ? 'Active' : 'Inactive'}
              </Typography>
          </Box>
        </PermissionGuard>
        
      )},
    },
    {
      field:'createdAt',
      headerName:'Created On',
      headerAlign:'center',
      flex: 1,
      filterable: false,
      sortingOrder: ['asc', 'desc'],
      valueGetter: (params) => {
        return params.row.createdAt? formatDateTime(params.row.createdAt):'';
      },
      renderCell:(params)=>{
        return (
          <Typography sx={{fontSize:'0.55rem'}}>{params.row.createdAt? formatDateTime(params.row.createdAt):''}</Typography>
        )
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      headerAlign:'center',
      flex: .5,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ p: 1, display: 'flex',flexDirection:'column',gap:1 ,justifyContent: 'center',alignItems:'center',width:'100%' }}>
          <IconButton 
            sx={{color: "blue",}}
            onClick={() => window.open(`/marketing/banner/view/${params.row.id}`, '_blank')} 
            size="small">
            <RemoveRedEyeIcon sx={{fontSize:'0.95rem'}}/>
          </IconButton>
          <PermissionGuard feature='banner' permission='canEdit'>
            <IconButton onClick={() => window.open(`/marketing/banner/${params.row.id}`,'_blank')} size="small" color='warning'>
              <Edit sx={{fontSize:'0.95rem'}}/>
            </IconButton>
          </PermissionGuard>
          {/* <IconButton onClick={() => deleteService(params.row.id)} size="small">
            <DeleteIcon />
          </IconButton> */}
        </Box>
      ),
    },
  ];
  
  return ( 
    <Box sx={{ overflow: "auto" }}>
      {/* {loading && <Loading/>} */}
        <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff", borderRadius: '.5rem' }}>
          <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between',alignItems:'center',px:'1%' }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {/* <MultiColumnFilter
                filterableColumns={filterableColumns}
                onApplyFilter={handleApplyFilter}
                externalClear={clearMultiFilter}
              /> */}
              {/* <ExportAll
                paginationModel={paginationModel} 
                columns={columns} 
                // statusOptions={statusOptions} 
              /> */}
            </Box>
            
            {/* <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} /> */}
          </Box>
          <DataGrid
            rows={list}
            columns={columns.map((col) => ({
              ...col,
              // flex: col.flex || 1, // Ensure columns resize dynamically
              minWidth: isSm && (col.minWidth || 200), // Set a minimum width to avoid overlap
            }))}
            getRowId={(row) => row.id}
            //checkboxSelection={true}
            rowCount={allRowCount}  // Use the length of the filtered list
            pageSizeOptions={[5, 10, 20, 50, 100]}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={handlePaginationChange}

            // filterModel={filterModel}

            sortingMode="server"
            sortModel={sortModel}                  
            onSortModelChange={handleSortingChange}
            disableMultiSort={true}

            loading={loading}

            disableColumnMenu
            disableRowSelectionOnClick
            slots={{
                // toolbar: GridToolbar,                        
                loadingOverlay: Loading,
                noRowsOverlay: NoRowsLayout,
            }}
            autoHeight
            getRowHeight={() => 'auto'}
            sx={{
                '& .MuiDataGrid-cell': {
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
                },
                '& .MuiDataGrid-columnHeaders': {
                  borderBottom: '2px solid rgba(224, 224, 224, 1)',
                  borderTop: '2px solid rgba(224, 224, 224, 1)',
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  p:0,
                  height: 'fit-content',
                  minHeight:'0 !important',
                  height:'2rem'
                },
                '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                '&:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
                },
                '& .MuiDataGrid-row': {
                '&:last-child .MuiDataGrid-cell': {
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnSeparator': {
                display: 'none',
                },
            }}
            />
        </Box>
    </Box>
  );
}

export default SliderList;
